import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import Card from "react-bootstrap/Card";
import NavDropdown from "react-bootstrap/NavDropdown";
import { logDOM } from "@testing-library/react";
import Nav from "react-bootstrap/Nav";
import Button from "react-bootstrap/Button";
import ModalLogoutCustom from "layouts/ModalLogoutCustom";
import { useAppDispatch, useAppSelector } from "../redux/store/configureStore";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import HandshakeIcon from "@mui/icons-material/Handshake";
import InventoryIcon from "@mui/icons-material/Inventory";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
import PaidIcon from "@mui/icons-material/Paid";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import SettingsIcon from "@mui/icons-material/Settings";
import { getBusinessStatus } from "../redux/handlers/logic/getBusinessStatus.handler";
export function Menutop(param) {
    var selectbranchID = param.selectbranchID, setSelectBranchID = param.setSelectBranchID;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(0), 2), menuTopNew = _useState[0], setMenuTopNew = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), navDropdown1 = _useState1[0], setNavDropdown1 = _useState1[1];
    var location = useLocation();
    var hash = location.hash, pathname = location.pathname, search = location.search;
    var accessToken = localStorage.getItem("accessToken");
    var _useState2 = _sliced_to_array(useState(1), 2), businessStatus = _useState2[0], setBusinessStatus = _useState2[1];
    var memID = null;
    if (accessToken) {
        try {
            var base64Url = accessToken.split(".")[1];
            if (base64Url) {
                try {
                    var _payload_member;
                    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
                    var payload = JSON.parse(atob(base64));
                    memID = parseInt((_payload_member = payload.member) === null || _payload_member === void 0 ? void 0 : _payload_member.mb_mem_id) || null;
                } catch (error) {
                    console.error("Failed to decode access token payload:", error);
                }
            } else {
                console.error("Invalid access token format.");
            }
        } catch (error) {
            console.error("Invalid access token:", error);
        }
    }
    // let businessStatus = null;
    // if (accessToken) {
    //     try {
    //         const base64Url = accessToken.split(".")[1];
    //         if (base64Url) {
    //             try {
    //                 const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    //                 const payload = JSON.parse(atob(base64));
    //                 businessStatus = parseInt(payload.member?.bus_business_status) || null;
    //             } catch (error) {
    //                 console.error("Failed to decode access token payload:", error);
    //             }
    //         } else {
    //             console.error("Invalid access token format.");
    //         }
    //     } catch (error) {
    //         console.error("Invalid access token:", error);
    //     }
    // }
    var _useState3 = _sliced_to_array(useState({
        visible: false,
        textlogout: ""
    }), 2), modallogout = _useState3[0], setModallogout = _useState3[1];
    var getBusinessStatusReducer = useAppSelector(function(state) {
        return state.getBusinessStatusReducer;
    });
    useEffect(function() {
        setIsLoading(getBusinessStatusReducer.isFetching);
        if (getBusinessStatusReducer.data) {
            if (getBusinessStatusReducer.data.data.bus_business_status) {
                // if ( getBusinessStatusReducer.data.data.bus_business_status == 10 ) {
                //     setModallogout((prev) => ({
                //         ...prev,
                //         visible: true,
                //         textlogout: "บัญชีของคุณไม่ได้รับการอนุมัติ",
                //     }));
                //     return;
                // }
                setBusinessStatus(getBusinessStatusReducer.data.data.bus_business_status || "");
            }
        }
    }, [
        getBusinessStatusReducer
    ]);
    useEffect(function() {
        if (memID != null && memID != 0 && memID != undefined) {
            dispatch(getBusinessStatus(memID, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    }, []);
    useEffect(function() {
        var fetchData = function() {
            var _ref = _async_to_generator(function() {
                var getPathUrl, path_array, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                pathname.substring(1)
                            ];
                        case 1:
                            getPathUrl = _state.sent();
                            return [
                                4,
                                getPathUrl.split("/")
                            ];
                        case 2:
                            path_array = _state.sent();
                            setNavDropdown1(false);
                            if (path_array && path_array.length > 0) {
                                if (path_array[0] === "product") {
                                    setMenuTopNew(2);
                                } else if (path_array[0] === "contract") {
                                    setMenuTopNew(3);
                                } else if (path_array[0] === "report") {
                                    setNavDropdown1(true);
                                    if (path_array[1] === "buy") {
                                        setMenuTopNew(6.1);
                                    }
                                } else if (path_array[0] === "info") {
                                    setMenuTopNew(7);
                                } else {
                                    setMenuTopNew(1);
                                }
                            } else {
                                setMenuTopNew(1);
                            }
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            console.error("Error fetching data:", error);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchData();
        return function() {
            console.log("Component is unmounted.");
        };
    }, [
        menuTopNew
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "scroll-menu mb-4",
        children: [
            /*#__PURE__*/ _jsx(Card, {
                className: "card card-menu",
                children: /*#__PURE__*/ _jsx(Card.Body, {
                    className: "d-flex flex-wrap",
                    style: {
                        paddingBottom: "0.3vw",
                        paddingTop: "0.9vw"
                    },
                    children: /*#__PURE__*/ _jsxs(Nav, {
                        variant: "pills",
                        className: "justify-content-center pills-st-menu-1",
                        activeKey: menuTopNew,
                        children: [
                            /*#__PURE__*/ _jsx(Nav.Item, {
                                children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                    eventKey: "1",
                                    href: "/dashboard",
                                    className: "mb-2",
                                    children: [
                                        /*#__PURE__*/ _jsx(BusinessCenterIcon, {
                                            className: "icon-menu-st-1 mr-1 mb-1"
                                        }),
                                        " Dashboard"
                                    ]
                                })
                            }),
                            businessStatus === 3 && /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx(Nav.Item, {
                                        children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                            eventKey: "2",
                                            href: "/product",
                                            className: "mb-2",
                                            children: [
                                                /*#__PURE__*/ _jsx(InventoryIcon, {
                                                    className: "icon-menu-st-1 mr-1 mb-1"
                                                }),
                                                " สินค้าของฉัน"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsxs(NavDropdown, {
                                        title: /*#__PURE__*/ _jsxs(_Fragment, {
                                            children: [
                                                /*#__PURE__*/ _jsx(PaidIcon, {
                                                    className: "icon-menu-st-1 mr-1 mb-1"
                                                }),
                                                " รายรับ"
                                            ]
                                        }),
                                        children: [
                                            /*#__PURE__*/ _jsx(NavDropdown.Item, {
                                                eventKey: "5.2",
                                                href: "/billing",
                                                children: "ใบแจ้งหนี้"
                                            }),
                                            /*#__PURE__*/ _jsx(NavDropdown.Item, {
                                                eventKey: "5.3",
                                                href: "/invoice",
                                                children: "ใบเสร็จรับ"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Nav.Item, {
                                children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                    eventKey: "7",
                                    href: "/info",
                                    className: "mb-2",
                                    children: [
                                        /*#__PURE__*/ _jsx(AccountCircleIcon, {
                                            className: "icon-menu-st-1 mr-1 mb-1"
                                        }),
                                        " โปรไฟล์"
                                    ]
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsx(ModalLogoutCustom, {
                show: modallogout.visible,
                onHide: function() {
                    return setModallogout(function(prev) {
                        return _object_spread_props(_object_spread({}, prev), {
                            visible: false
                        });
                    });
                },
                textlogout: modallogout.textlogout,
                navigate: navigate
            })
        ]
    });
}
